var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{staticClass:"label text-body-1",class:_vm.labelStateClass,style:({ height: 'var(--r-space-lg)' }),attrs:{"align-items":"center"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }